/**
 * @generated SignedSource<<87213471601fd24b9323f73f53b03cfe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetListInput = {
  dataSource: string;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WAIntegrationListMutation$variables = {
  input: CreateWidgetListInput;
  storecastId: string;
};
export type WAIntegrationListMutation$data = {
  readonly dashboard: {
    readonly createWidgetList: {
      readonly id: string;
    };
  };
};
export type WAIntegrationListMutation = {
  response: WAIntegrationListMutation$data;
  variables: WAIntegrationListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetList",
        "kind": "LinkedField",
        "name": "createWidgetList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationListMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationListMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0eb8682372767d28ca34ececf956bd31",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationListMutation",
    "operationKind": "mutation",
    "text": "mutation WAIntegrationListMutation(\n  $storecastId: ID!\n  $input: CreateWidgetListInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetList(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "510949e8cc83b365eb1d52cf54f5cbbe";

export default node;
